<template>
  <section class="cities" @click="handlerClick">
    <svg class="cities__icon"><use xlink:href="#svg-pin"></use></svg>
    {{ userCity.cityPrintName }}
  </section>
</template>

<script>
import { mapState } from 'vuex';
import useModal from '@use/useModal/useModal';
import GuessCity from '@components/Cities/GuessCity.vue';

export default {
  name: 'Cities',
  data() {
    return {
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      userCity: ({ cities }) => cities.data?.userCity,
    }),
  },
  methods: {
    handlerClick() {
      this.modal.show(GuessCity, {}, { width: '340px' });
    },
  },
};
</script>

<style lang="scss" scoped>
.cities {
  display: flex;
  align-items: center;
  align-self: stretch;
  margin-right: 24px;
  font-weight: 500;
  font-size: rem(16);
  line-height: 100%;
  cursor: pointer;
  transition: 0.2s linear color;
  @include point-md {
    font-size: rem(14);
  }
  &:hover {
    color: var(--text-colour-secondary);
    .cities__icon {
      fill: var(--text-colour-secondary);
    }
  }
  &__icon {
    display: block;
    width: 18px;
    height: 18px;
    fill: var(--background-black);
    margin-right: 4px;
    transform: translateY(-2px);
    transition: 0.2s linear fill;
    @include point-md {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
